<template>
  <div class="content content-boxed">
    <div class="row">

      <div v-if="actualBundle.cars.length == 0" class="col-xs-12">
        <h2 class="block-title">{{ textNoEVCarRegistered[actualLanguage] }}</h2>
      </div>



      <div v-if="actualBundle.cars.length > 0" class="col-xs-12">
        <h1 class="font-w300 push">{{ labelTopPage[actualLanguage] }}</h1>
        <div class="block block-rounded">
          <div class="block-header">
            <h2 class="block-title">{{ labelTimeSelectorTitle[actualLanguage] }}</h2>
          </div>
          <div class="block-content">
            <range-picker @refresh="refreshData"></range-picker>
          </div>
        </div>
      </div>

      <div v-if="actualBundle.cars.length > 0" class="col-xs-12 col-sm-12">

        <select v-model="selectedCar" class="push">
          <option v-for="(charge, index) in actualBundle.cars" :key="index" :value="index">{{ actualBundle.cars[index].ReferenceName }}</option>
        </select>

        <div class="block block-rounded">
          <div class="block-content">
            <div class="row">

              <div class="col-xs-12 col-sm-6">
                <p><img width="280px" :src="`cars/${actualBundle.cars[selectedCar].CarData.carInfo.carPictureFile}` | s3Image"></p>
              </div>
              <div class="col-xs-12 col-sm-3">
                <div class="block block-rounded block-bordered">
                  <div class="block-content block-content-full bg-success text-center push">
                    <div class="font-w400 text-white animated fadeIn">{{ labelCarTotalSavings[actualLanguage] }}</div>
                    <span class="h2 font-w600 font-s30 text-white animated fadeIn">{{ actualBundle.cars[selectedCar].CarData.carInfo.lifeTimeMoneySavings | toCurrency }}</span>
                  </div>
                  <p class="text-muted animated fadeIn text-center">
                    <small><i class="si si-calendar"></i> {{ labelCarTotalSavingsStartDate[actualLanguage] }} {{ actualBundle.cars[selectedCar].CarData.carInfo.startingDate }}</small>
                  </p>
                </div>
              </div>

              <div class="col-xs-12 col-sm-3">
                <div class="block block-rounded block-bordered">
                  <div class="block-content block-content-full bg-success text-center push">
                    <div class="font-w400 text-white animated fadeIn">{{ labelCarTotalGreenSavings[actualLanguage] }}</div>
                    <span class="h2 font-w600 font-s30 text-white animated fadeIn">{{ actualBundle.cars[selectedCar].CarData.carInfo.lifeTimeGreenGazSavings | round }} T CO2</span>
                  </div>
                  <p class="text-muted animated fadeIn text-center">
                    <small><i class="si si-calendar"></i> {{ labelCarTotalSavingsStartDate[actualLanguage] }} {{ actualBundle.cars[selectedCar].CarData.carInfo.startingDate }}</small>
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="actualBundle.cars.length > 0" class="row">
      <div class="col-sm-12">
        <h3 class="content-heading">{{ labelPeriodSummaryTitle[actualLanguage] }} <span class="text-muted">({{startDate | formatDate }} {{ labelPeriodSummaryTitle2[actualLanguage] }} {{endDate | formatDate}})</span></h3>
      </div>
    </div>

    <div v-if="actualBundle.cars.length > 0" class="row-flex row-flex__5 dashboar-month-data">
      <div>
        <div class="block block-rounded">
          <div class="block-content text-center">
            <i class="fa fa-bolt fa-3x text-success"></i>
			<p><span class="h5 text-muted">{{ labelPeriodSummaryChargeCosts[actualLanguage] }}</span></p>
            <p class="h1 font-w700">{{totalCost | round}} <span class="h2 text-muted">$</span></p>
          </div>
        </div>
      </div>
      <div>
        <div class="block block-rounded">
          <div class="block-content text-center">
            <i class="fa fa-clock-o fa-3x text-success"></i>
			<p><span class="h5 text-muted">{{ labelPeriodSummaryChargeTime[actualLanguage] }}</span></p>
            <p class="h1 font-w700">{{ totalChargeTime | toMinutes }}</p>
          </div>
        </div>
      </div>
      <div>
        <div class="block block-rounded">
          <div class="block-content text-center">
            <i class="fa fa-download fa-3x text-success"></i>
			<p><span class="h5 text-muted">{{ labelPeriodSummaryPower[actualLanguage] }}</span></p>
            <p class="h1 font-w700">{{ totalEnergy | round }} <span class="h2 text-muted">kWh</span></p>
          </div>
        </div>
      </div>
      <div>
        <div class="block block-rounded">
          <div class="block block-rounded">
            <div class="block-content text-center">
              <i class="fa fa-money fa-3x text-success"></i>
			  <p><span class="h5 text-muted">{{ labelPeriodSummaryGazSaving[actualLanguage] }}</span></p>
              <p class="h1 font-w700">{{ totalMoneySaving | toCurrency }} <span class="h2 text-muted"></span></p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="block block-rounded">
          <div class="block block-rounded">
            <div class="block-content text-center">
              <i class="fa fa-leaf fa-3x text-success"></i>
			  <p><span class="h5 text-muted">{{ labelPeriodSummaryGreenGazSaving[actualLanguage] }}</span></p>
              <p class="h1 font-w700">{{ totalgreenGazSaving | round }} <span class="h2 text-muted">&nbsp;T&nbsp;CO2</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="actualBundle.cars.length > 0" class="row">
      <div class="col-sm-12 col-md-6">
        <div class="block">
          <div class="block-header">
            <h3 class="block-title">{{ labelPeriodSummaryGraphCharge[actualLanguage] }} <span class="text-muted">({{startDate | formatDate }} au {{endDate | formatDate}})</span></h3>
          </div>
          <div class="block-content block-content-full bg-gray-lighter text-center">
            <!-- <monthly-fee-chart :charges="charges"></monthly-fee-chart> -->
            <bar-chart v-if="chargeMonthChartData" :chartData="chargeMonthChartData" ></bar-chart>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="block">
          <div class="block-header">
            <h3 class="block-title">{{ labelPeriodSummaryGraphCosts[actualLanguage] }} <span class="text-muted">({{startDate | formatDate }} au {{endDate | formatDate}})</span></h3>
          </div>
          <div class="block-content block-content-full bg-gray-lighter text-center">
            <bar-chart v-if="costMonthChartData" :chartData="costMonthChartData" ></bar-chart>
          </div>
        </div>
      </div>
    </div>


    <div v-if="actualBundle.cars.length > 0" class="row">

      <div class="col-sm-12">
        <div class="block">
          <div class="block-header">
            <h3 class="block-title">{{ labelPeriodSummaryTableTitle[actualLanguage] }} </h3>
          </div>
          <div class="block-content block-content-full">
            <div class="table-responsive">
              <table class="table remove-margin-b font-s13">
                <thead>
                  <tr>
                    <th>{{ labelPeriodSummaryTableColStart[actualLanguage] }}</th>
                    <th>{{ labelPeriodSummaryTableColEnd[actualLanguage] }}</th>
                    <th>{{ labelPeriodSummaryTableColEnergy[actualLanguage] }}</th>
                    <th>{{ labelPeriodSummaryTableColCost[actualLanguage] }}</th>
                    <th>{{ labelPeriodSummaryTableColSaving[actualLanguage] }}</th>
                    <th>{{ labelPeriodSummaryTableColGreenSaving[actualLanguage] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="charge in carChargeList">
                    <td class="font-w600 text-muted">{{ charge.startTime }}</td>
                    <td class="hidden-xs text-muted " >{{ charge.endTime }}</td>
                    <td class="font-w600 text-success " >{{ charge.energy | round }}</td>
                    <td class="font-w600 text-success " >{{ charge.cost | round }}</td>
                    <td class="font-w600 text-success " >{{ charge.moneySaving | round }}</td>
                    <td class="font-w600 text-success " >{{ charge.greenGazSaving | round }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let moment = require('moment');

import {mapState, mapGetters} from 'vuex'
import LineChart from '@/components/LineChart.js'
import BarChart from '@/components/BarChart.js'
import RangePicker from '@/components/RangePicker'
import MonthlyFeeChart from '@/components/MonthlyFeeChart'

let getTotalFromKey = function(key, chargeArray) {
  let total = 0;
  for (let charge of chargeArray) {
    total += charge[key];
  }
  return total
}

export default {
  name: 'dashboardHome',
  components: { BarChart, LineChart, RangePicker },
  data () {
    return {
      msg: 'Mon e-portail',
      selectedCar: 0,
      chargeMonthChartData: null,
      costMonthChartData: null,
      actualLanguage : "FR",
      carChargeList : [],
      textNoEVCarRegistered: {FR: "Vous n'avez pas de Véhicule Électrique d'enregistré, vous devez utiliser le menu configuration pour enregistrer un véhicule.", EN: "You don't have any registered Electric Vehicle, you must use the configuration menu to add one."},
      labelTopPage: {FR: 'Ports de recharge', EN: 'Charging ports'},
      labelTimeSelectorTitle: {FR: 'Plage à observer', EN: 'Period selector'},
      labelCarTotalSavings: {FR: 'Économies', EN: 'Savings'},
      labelCarTotalGreenSavings: {FR: 'Écologie', EN: 'Green gaz savings'},
      labelCarTotalSavingsStartDate: {FR: 'Depuis le ', EN: 'Since '},
      labelPeriodSummaryTitle: {FR: 'BILAN DE PÉRIODE :', EN: 'PERIOD SUMMARY :'},
      labelPeriodSummaryTitle2: {FR: 'AU', EN: 'TO'},
      labelPeriodSummaryChargeCosts: {FR: 'Coût de charge', EN: 'Charge costs'},
      labelPeriodSummaryChargeTime: {FR: 'Temps de charge', EN: 'Charge time'},
      labelPeriodSummaryPower: {FR: 'Consommation', EN: 'Consumption'},
      labelPeriodSummaryGazSaving: {FR: "Économie d'essence", EN: 'Gaz savings'},
      labelPeriodSummaryGreenGazSaving: {FR: "Économie écologique", EN: 'Green gaz savings'},
      labelPeriodSummaryGraphCharge: {FR: "Charge en kWh :", EN: 'Charge in kWh :'},
      labelPeriodSummaryGraphCosts: {FR: "Coûts des charges ($) :", EN: 'Charge costs ($) :'},
      labelPeriodSummaryGraphCostsBubble: {FR: 'Coût charge', EN: 'Charge cost'},
      labelPeriodSummaryTableTitle: {FR: "Liste des charges", EN: 'Charges list'},
      labelPeriodSummaryTableColStart: {FR: "Début", EN: 'Start'},
      labelPeriodSummaryTableColEnd: {FR: "Fin", EN: 'End'},
      labelPeriodSummaryTableColEnergy: {FR: "Énergie (kWh)", EN: 'Energy (kWh)'},
      labelPeriodSummaryTableColCost: {FR: "Coût Charge ($)", EN: 'Charge Cost ($)'},
      labelPeriodSummaryTableColSaving: {FR: "Économie ($)", EN: 'Savings ($)'},
      labelPeriodSummaryTableColGreenSaving: {FR: "T CO2", EN: 'T CO2'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

    }
  },


  watch: {
    selectedCar() {
      this.getCarChargeList()
    },

    startDate() {
      this.getCarChargeList()
    }
  },



  computed: {
    ...mapState('chargesStore',['startDate', 'endDate']),
    //...mapGetters('chargesStore',['chargesForDevice', 'monthChargeArrayForDevice']),
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    
    totalCost() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('cost', this.carChargeList)
    },
    totalChargeTime() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('chargeTime', this.carChargeList)
    },
    totalEnergy() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('energy', this.carChargeList)
    },
    totalMoneySaving() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('moneySaving', this.carChargeList)
    },
    totalgreenGazSaving() {
      if (this.carChargeList.length == 0) return 0;
      return getTotalFromKey('greenGazSaving', this.carChargeList)
    }
    
  },




  methods: {
    refreshData(dates) {
      this.$store.dispatch('chargesStore/setStartDate', dates.startDate)
      this.$store.dispatch('chargesStore/setEndDate', dates.endDate)
      this.getCarChargeList
    },

    setChargeMonthChartData () {
      if (this.carChargeList.length) {
        let myChargesList = this.carChargeList
        let time = []
        let y1   = []
        let y2   = []
        for (let charge of myChargesList) {
          const labelX = `${charge.startTime.split(' ')[2]} - ${charge.endTime.split(' ')[2]}`;
          time.push(labelX)
          y1.push(charge.energy)
        }

        this.chargeMonthChartData = {
          labels: time,
          datasets: [{
            // bezierCurve: false,
            label: 'Charge (kWh)',
            backgroundColor: 'rgba(70, 195, 123, 0.8)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: y1 }]

          }
      }
    },
    setCostMonthChartData () {
      if (this.carChargeList.length == 0) return ;
      let myChargesList = this.carChargeList
      let time = []
      let y1   = []
      let y2   = []
      for (let charge of myChargesList) {
        const labelX = `${charge.startTime.split(' ')[2]} - ${charge.endTime.split(' ')[2]}`;
        time.push(labelX)
        y1.push(charge.cost)
      }
      

      this.costMonthChartData = {
        labels: time,
            datasets: [{
              // bezierCurve: false,
              label: 'Charge ($)',
              backgroundColor: 'rgba(70, 195, 123, 0.8)',
              borderColor: 'rgba(5, 210, 92, .25)',
              pointBackgroundColor: 'rgba(68, 180, 166, 1)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
              data: y1 }]
        }
    },


    getCarChargeList(){
      //'start': 1596108413,
      //'end': 1600000000,
      //console.log('===START DATE====')
      //console.log(this.startDate)
      //console.log('===END DATE====')
      //console.log(this.endDate)


      if(this.actualBundle.cars.length>0){
        var requestData = { 'postAction':'GetCarCharges',
                            'carId': this.actualBundle.cars[this.selectedCar].CarData.carId,
                            'start': this.startDate,
                            'end': this.endDate,
                            }

        this.$store.dispatch('sessionStore/postCar', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                  this.carChargeList = response.data.ChargeList
                  //console.log('===CHARGES RECEIVE====')
                  this.setChargeMonthChartData()
                  this.setCostMonthChartData()
                }
                else{ 
                  window.alert(this.messagePostFail[this.actualLanguage])
                  }
            })
      } 
    }

  },

  mounted() {
    this.getCarChargeList()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>





// WEBPACK FOOTER //
// Home.vue?24cc2c28